(function () {
  'use strict';
  var core = window.BFFJourneyCore, node = document.getElementById('BFFJourneyText'), text = node ? JSON.parse(node.textContent) : {};
  if (!core) return;
  var nearby = new Set(['34684','34683','34685','34695','34677','34688','34689','34698','34660','33761','33763','33765','33759','33760','33764','33626','33755','33756','33762','33767']);
  var places = {"34684":{"city":"Palm Harbor","province":"FL","country":"US"},"34683":{"city":"Palm Harbor","province":"FL","country":"US"},"34685":{"city":"Palm Harbor","province":"FL","country":"US"},"34695":{"city":"Safety Harbor","province":"FL","country":"US"},"34677":{"city":"Oldsmar","province":"FL","country":"US"},"34688":{"city":"Tarpon Springs","province":"FL","country":"US"},"34689":{"city":"Tarpon Springs","province":"FL","country":"US"},"34698":{"city":"Dunedin","province":"FL","country":"US"},"34660":{"city":"Ozona","province":"FL","country":"US"},"33761":{"city":"Clearwater","province":"FL","country":"US"},"33763":{"city":"Clearwater","province":"FL","country":"US"},"33765":{"city":"Clearwater","province":"FL","country":"US"},"33759":{"city":"Clearwater","province":"FL","country":"US"},"33760":{"city":"Clearwater","province":"FL","country":"US"},"33764":{"city":"Clearwater","province":"FL","country":"US"},"33626":{"city":"Tampa","province":"FL","country":"US"},"33755":{"city":"Clearwater","province":"FL","country":"US"},"33756":{"city":"Clearwater","province":"FL","country":"US"},"33762":{"city":"Clearwater","province":"FL","country":"US"},"33767":{"city":"Clearwater Beach","province":"FL","country":"US"}};
  var addressKey = 'bff-delivery-address-v1';
  function addressFor(value) {
    var zip = core.zip(value);
    return zip ? Object.assign({ zip: zip, country: 'US' }, places[zip] || {}) : null;
  }
  function storedAddress() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(addressKey));
      return saved && Date.now() - saved.savedAt < 7200000 ? addressFor(saved.zip) : null;
    } catch (error) { return null; }
  }
  function rememberAddress(value) {
    var address = addressFor(value);
    try {
      if (address) sessionStorage.setItem(addressKey, JSON.stringify({ zip: address.zip, savedAt: Date.now() }));
      else sessionStorage.removeItem(addressKey);
    } catch (error) {}
    return address;
  }
  function checkoutPickup(form) {
    var area = form.querySelector('[data-bff-delivery-fields]');
    var mode = form.elements.namedItem('attributes[Order type]');
    var snapshot = form.querySelector('[data-bff-cart-address]');
    return Boolean((area && pickup(area)) || (mode && mode.value === 'Pickup at store') || (!mode && snapshot && snapshot.dataset.orderType === 'Pickup at store'));
  }
  function checkoutAddress(form) {
    if (checkoutPickup(form)) return null;
    var snapshot = form.querySelector('[data-bff-cart-address]');
    var zipField = form.querySelector('[data-bff-journey-zip]');
    if (zipField) return addressFor(zipField.value);
    if (snapshot && snapshot.dataset.zip) return addressFor(snapshot.dataset.zip);
    return snapshot && snapshot.dataset.hasItems === 'true' ? storedAddress() : null;
  }
  function checkoutDetails(form) {
    if (!form || checkoutPickup(form)) return null;
    var address = checkoutAddress(form);
    var recipient = form.elements.namedItem('attributes[Recipient Name]');
    var fullName = recipient && typeof recipient.value === 'string' ? recipient.value.trim().replace(/\s+/g, ' ') : '';
    if (fullName) {
      var names = fullName.split(' ');
      address = Object.assign({}, address || {}, { first_name: names.length > 1 ? names.shift() : '', last_name: names.join(' ') });
    }
    return address;
  }
  function prepareCheckout(form) {
    if (!form || !form.matches('form[is="m-cart-form"]')) return;
    if (!form.dataset.bffOriginalAction) form.dataset.bffOriginalAction = form.getAttribute('action') || '/cart';
    var url = new URL(form.dataset.bffOriginalAction, window.location.origin), address = checkoutDetails(form);
    if (url.origin !== window.location.origin) return;
    if (address) Object.keys(address).forEach(function (key) { url.searchParams.set('checkout[shipping_address][' + key + ']', address[key]); });
    form.setAttribute('action', url.pathname + url.search + url.hash);
  }
  function restoreAddress() {
    var address = storedAddress();
    if (address) document.querySelectorAll('[data-bff-journey-zip]').forEach(function (field) { if (!field.value) field.value = address.zip; });
    document.querySelectorAll('form[is="m-cart-form"]').forEach(prepareCheckout);
  }
  window.BFFCheckoutPrefill = { remember: rememberAddress, prepare: prepareCheckout, address: checkoutDetails };
  document.addEventListener('submit', function (event) { prepareCheckout(event.target); }, true);
  function pickup(area) { var button = area.querySelector('[data-bff-mode-button="pickup"]'); return button && button.getAttribute('aria-pressed') === 'true'; }
  function calendar(area) {
    if (!area) return;
    var isPickup = pickup(area), mode = isPickup ? 'pickup' : 'delivery', field = area.querySelector('[data-bff-date]'), zip = area.querySelector('[data-bff-journey-zip]'), time = area.querySelector('.bff-df__field--time select');
    if (field) {
      field.min = core.earliest(mode);
      var previousDate = field.value;
      var unavailable = previousDate && (previousDate < field.min || core.sunday(previousDate));
      if (unavailable) {
        field.value = '';
        field.dataset.bffDateReset = 'true';
        document.dispatchEvent(new CustomEvent('bff:date:unavailable', { detail: { context: area.dataset.bffContext, reason: core.sunday(previousDate) ? 'sunday' : 'cutoff' } }));
      } else if (field.value) {
        delete field.dataset.bffDateReset;
      }
      var dateWrap = field.closest('.bff-df__field');
      var guidance = dateWrap && dateWrap.querySelector('[data-bff-date-guidance]');
      if (dateWrap && !guidance) {
        guidance = document.createElement('p');
        guidance.className = 'bff-df__help';
        guidance.dataset.bffDateGuidance = '';
        guidance.setAttribute('role', 'status');
        guidance.setAttribute('aria-live', 'polite');
        dateWrap.appendChild(guidance);
      }
      var firstDay = new Date(field.min + 'T12:00:00Z');
      var firstDayLabel = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' }).format(firstDay);
      var dateMessage = field.dataset.bffDateReset ? text.dateChanged : (isPickup ? text.earliestPickup : text.earliestDelivery);
      if (guidance && dateMessage) guidance.textContent = dateMessage.replace('[date]', firstDayLabel);
      var prefix = area.dataset.bffContext === 'product' ? 'properties' : 'attributes';
      field.name = prefix + '[' + (isPickup ? 'Pickup date' : 'Preferred delivery date') + ']';
      if (area.dataset.bffContext === 'cart') {
        var p = core.clock(), today = p.year + '-' + p.month + '-' + p.day;
        field.dataset.bffMode = mode;
        if (time) Array.from(time.options).forEach(function (opt) {
          if (opt.value === 'Morning') { opt.disabled = isPickup && field.value === today && Number(p.hour) >= 12; opt.textContent = isPickup ? text.morning : text.deliveryMorning; }
          if (opt.value === 'Afternoon') { opt.disabled = false; opt.textContent = isPickup ? (field.value && new Date(field.value + 'T12:00:00Z').getUTCDay() === 6 ? text.saturday : text.afternoon) : text.deliveryAfternoon; }
        });
        if (time && time.selectedOptions.length && time.selectedOptions[0].disabled) time.value = '';
      }
    }
    if (zip) { zip.closest('.bff-df__field').hidden = isPickup; zip.disabled = isPickup; }
    var hiddenTime = area.querySelector('[data-bff-journey-time]');
    if (hiddenTime) { hiddenTime.disabled = isPickup; hiddenTime.name = 'properties[Preferred delivery time]'; }
    if (area.dataset.bffContext === 'cart') {
      var help = area.querySelector('.bff-df__field--date .bff-df__help');
      if (help) help.textContent = isPickup ? text.pickupHint : text.deliveryHint;
    }
  }
  window.BFFJourneyCalendar = calendar;
  function check(area) {
    var input = area.querySelector('[data-bff-journey-zip]'), result = area.querySelector('[data-bff-zip-result]');
    if (!input || !result) return;
    var value = core.zip(input.value);
    rememberAddress(value);
    input.setCustomValidity(value ? '' : text.invalid);
    result.textContent = !value ? text.invalid : (nearby.has(value) ? text.local : text.outside);
    result.hidden = false;
    if (value) input.value = value;
    result.dataset.bffAreaState = !value ? 'invalid' : (nearby.has(value) ? 'eligible' : 'review');
    input.setAttribute('aria-invalid', value ? 'false' : 'true');
    if (!value) input.focus();
  }
  function totals() {
    document.querySelectorAll('[data-bff-selection]').forEach(function (panel) {
      var section = panel.closest('product-info') || document, extras = section.querySelector('[data-bff-extras]'), amount = Number(panel.dataset.basePrice || 0), unique = new Set();
      if (extras) {
        var tier = section.querySelector('[data-bff-tier-variant]:checked');
        if (tier) amount += Number(tier.dataset.bffPrice || 0);
        extras.querySelectorAll('[data-bff-addon]:checked').forEach(function (input) {
          if (!unique.has(input.dataset.variantId)) { unique.add(input.dataset.variantId); amount += Number(input.dataset.bffPrice || 0); }
        });
      }
      var selectedTier = section.querySelector('[data-bff-tier-variant]:checked');
      var extraPrice = selectedTier ? Number(selectedTier.dataset.bffPrice || 0) : 0;
      var unitAmount = Number(panel.dataset.basePrice || 0) + extraPrice;
      var formatMoney = function (cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: panel.dataset.currency || 'USD' }).format(cents / 100); };
      if (selectedTier) {
        var priceBox = section.querySelector('.product-block-group--price [data-bff-unit-price]');
        if (priceBox) {
          var displayMoney = function (cents) { return formatMoney(cents) + (priceBox.dataset.bffShowCurrency === 'true' ? ' ' + (panel.dataset.currency || 'USD') : ''); };
          priceBox.querySelectorAll('.m-price__regular > .m-price-item--regular, .m-price-item--sale').forEach(function (node) { node.textContent = displayMoney(unitAmount); });
          var compare = Number(priceBox.dataset.bffComparePrice || 0);
          if (compare > Number(priceBox.dataset.bffUnitPrice)) {
            var compareNode = priceBox.querySelector('s.m-price-item--regular');
            if (compareNode) compareNode.textContent = displayMoney(compare + extraPrice);
            if (priceBox.dataset.saleBadgeType === 'percentage') {
              var badge = priceBox.querySelector('.m-price__badge-sale span');
              if (badge) badge.textContent = '-' + Math.round((compare - Number(priceBox.dataset.bffUnitPrice)) * 100 / (compare + extraPrice)) + '%';
            }
          }
        }
      }
      var pairTotal = section.querySelector('[data-bff-pair-total]');
      if (pairTotal) {
        pairTotal.textContent = formatMoney(unitAmount + Number(pairTotal.dataset.bffGiftPrice || 0));
        var pairSize = section.querySelector('[data-bff-pair-size]');
        var nativeSize = section.querySelector('[data-bff-native-formats] input:checked');
        if (pairSize) pairSize.textContent = selectedTier ? selectedTier.value : (nativeSize ? nativeSize.value : '');
      }
      var form = section.querySelector('.m-product-form--main form');
      var quantityField = form && form.elements.namedItem('quantity');
      amount *= Math.max(1, Number(quantityField && quantityField.value || 1));
      var output = panel.querySelector('[data-bff-selection-total]');
      if (output) output.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: panel.dataset.currency || 'USD' }).format(amount / 100);
    });
  }
  function ready() { restoreAddress(); document.querySelectorAll('[data-bff-delivery-fields]').forEach(calendar); totals(); }
  document.addEventListener('click', function (event) {
    var close = event.target.closest && event.target.closest('[data-bff-area-close]');
    if (close) { close.closest('dialog').close(); return; }
    if (event.target.matches('[data-bff-area-dialog]')) {
      var bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
      return;
    }
    var button = event.target.closest && event.target.closest('[data-bff-mode-button], [data-bff-journey-check]');
    if (!button) return;
    var area = button.closest('[data-bff-delivery-fields]');
    if (button.hasAttribute('data-bff-journey-check')) check(area); else setTimeout(function () { calendar(area); }, 0);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target.matches('[data-bff-journey-zip]')) { event.preventDefault(); check(event.target.closest('[data-bff-delivery-fields]')); }
  });
  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-bff-journey-zip]')) { rememberAddress(''); event.target.setCustomValidity(''); event.target.removeAttribute('aria-invalid'); var result = event.target.closest('[data-bff-delivery-fields]').querySelector('[data-bff-zip-result]'); if (result) result.hidden = true; }
  });
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-bff-date], [data-bff-journey-zip]')) {
      var area = event.target.closest('[data-bff-delivery-fields]');
      if (event.target.matches('[data-bff-date]')) calendar(area);
      var zip = area && area.querySelector('[data-bff-journey-zip]');
      if (zip && !pickup(area) && core.zip(zip.value)) check(area);
    }
    if (event.target.matches('[data-bff-addon]')) {
      var root = event.target.closest('[data-bff-extras]');
      if (root) root.querySelectorAll('[data-bff-addon]').forEach(function (input) { if (input.dataset.variantId === event.target.dataset.variantId) input.checked = event.target.checked; });
    }
    totals();
  });
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    var section = event.target.closest && event.target.closest('product-info') || document;
    section.querySelectorAll('[data-bff-selection]').forEach(function (panel) { panel.dataset.basePrice = variant.price; });
    totals();
  });
  document.addEventListener('shopify:section:load', ready);
  window.addEventListener('pageshow', ready);
  window.addEventListener('focus', ready);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) ready(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();


